import { connect } from 'react-redux';
import ActionComponent from './view';

const mapStateToProps = null;

export default connect(mapStateToProps)(ActionComponent);
